import React from 'react';

import { motion, useScroll, useSpring } from 'framer-motion';

import ErrorBoundary from '@/components/ErrorBoundary';
import OfflineBanner from '@/components/OfflineBanner';
import WhatsAppButton from '@/components/WhatsAppButton';

const CursorSparkleTrail = React.lazy(() => import('@/components/CursorSparkleTrail'));

import Footer from './Footer';
import Header from './Header';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div className="selection:bg-primary-100 selection:text-primary-600 dark:selection:bg-primary-900 dark:selection:text-primary-300 to-primary-50/20 flex min-h-screen flex-col bg-gradient-to-b from-white dark:from-neutral-950 dark:to-neutral-950/20">
      <a
        href="#main-content"
        className="focus:text-primary-600 focus:ring-primary-500 sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:rounded-2xl focus:bg-white focus:px-6 focus:py-3 focus:text-sm focus:font-bold focus:shadow-2xl focus:ring-2 focus:outline-none">
        Skip to main content
      </a>

      <motion.div
        className="from-primary-400 via-primary-500 to-secondary-500 fixed top-0 right-0 left-0 z-[100] h-[5px] origin-left bg-gradient-to-r shadow-[0_2px_10px_rgba(106,160,212,0.3)]"
        style={{ scaleX }}
      />
      <OfflineBanner />
      <Header />
      <React.Suspense fallback={null}>
        <CursorSparkleTrail />
      </React.Suspense>
      <main id="main-content" className="flex-grow" role="main" tabIndex={-1}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </main>
      <Footer />
      <section aria-label="Contact">
        <WhatsAppButton />
      </section>
    </div>
  );
};

export default MainLayout;
